// extracted by mini-css-extract-plugin
export default {"form":"Form_form__MCyoe","row":"Form_row__7aCmn","buttons":"Form_buttons__thbmJ","flag":"Form_flag__umYxs","loading":"Form_loading__RL88f"};